module.exports = exports = require('./pls');
exports.Utils = require('./utils');
exports.OPLS = require('./opls');



// WEBPACK FOOTER //
// ./node_modules/ml-pls/src/index.js